const findParentComp = (editor, findCondition, component ) =>{

    const wrapperComp = editor.DomComponents.getWrapper();
    const dataItemsContainers= wrapperComp.find(findCondition);

    let dataItemsContainer = '';
    dataItemsContainers.forEach((comp) => {
        if (comp.find(`[id=${component.attributes.attributes.id}]`).length > 0){
            dataItemsContainer = comp;
        }
        
    }) 

    return dataItemsContainer;

}

const assignAnnotationToComp = (comp, annotationName) => {

    if(comp.attributes.attributes.annotationname === undefined){
        comp.addAttributes({annotationname: annotationName});
    }
    else if(comp.attributes.attributes.annotationname !== annotationName){
        comp.attributes.attributes.annotationname = annotationName;
    }

}

const removeAnnotationFromComp = (component) => {

    const attr = component.getAttributes();
    if( 'annotationname' in attr){
        delete attr.annotationname;
        component.setAttributes(attr);
    }
}

const findChildIndex = (component) => {
    
    const componentCid = component.cid;

    let index = -1;

    component.parent().components().models.forEach( (comp,compIndex) => {
        if(comp.cid === componentCid){
            index = compIndex;
        }
    })
    return index;
}

const findTdIndex = (component) => {

    const parentComp = component.parent();
    let compIndex = -1
    parentComp.find('td').forEach( (comp,index) => {
        if (comp.attributes.attributes.id === component.attributes.attributes.id){
            compIndex = index;
        }
    })
    return compIndex;

}
 
const assignAnnotationToSiblings = (annotationName, tBodyComponent, label) => {

    const siblingComps = tBodyComponent.find(`[${label}=true]`);

    siblingComps.forEach( sibling => {
        
        if(annotationName !== undefined){
            assignAnnotationToComp(sibling, annotationName);
        }
        else{
            removeAnnotationFromComp(sibling);
        }

    })
   

}

const assignAnnotationToTdSiblings = (annotationName,dataItemsContainer,component) => {

    const compIndex = findTdIndex(component);

    const siblingRows = dataItemsContainer.find(`[dataitem=true]`);
    siblingRows.forEach( (sibrow) => {
        
        const tdComp = sibrow.find('td')[compIndex];
            
        if(tdComp !== undefined && component !== tdComp){
            
            assignAnnotationToComp(tdComp, annotationName);
        }
    })

}

const assignAnnotationToInsideTbSiblings = (annotationName, dataItemsContainer, component, childIndex) => {

    const compIndex = findTdIndex(component.parent());
    const siblingRows = dataItemsContainer.find(`[dataitem=true]`);
    siblingRows.forEach( (sibrow) => {
        
        const tdComp = sibrow.find('td')[compIndex];
            
        if(tdComp !== undefined && component !== tdComp){
            
            assignAnnotationToComp(tdComp.components().models[childIndex], annotationName);
        }
    })


}

const assignAnnotationToLiSiblings = (editor,annotationName,component) => {

    const dataItemsContainer = findParentComp(editor, 'ul',component)
    assignAnnotationToSiblings(annotationName,dataItemsContainer, 'dataitem')

}


const assignSameAnnotationToListItemsComp = (component) => {

    const annotationName = component.attributes.attributes.annotationname;
    let tBodyComponent = component;
    try {
        tBodyComponent = component.parent().parent().parent();
    } catch (error) {
        tBodyComponent = component;
    }

    if(component.attributes.attributes.listimage !== undefined ){
        assignAnnotationToSiblings(annotationName, tBodyComponent, 'listimage')
    }
    if(component.attributes.attributes.listtitle !== undefined){
        assignAnnotationToSiblings(annotationName, tBodyComponent, 'listtitle')   
    }
    if(component.attributes.attributes.listdescription !== undefined){
        assignAnnotationToSiblings(annotationName, tBodyComponent, 'listdescription')
    }


}

const assignToSiblingBasedOnAttr = (component, annotationName,dataItemsContainer,attr) => {

    if(component.attributes.attributes[attr] !== undefined ){
        assignAnnotationToSiblings(annotationName, dataItemsContainer, attr)
    }

}

const assignSameAnnotationToGenericGetItemsComp = (editor,component) => {

    const dataItemsContainer = findParentComp(editor,`[dataitems]`,component)

    const annotationName = component.attributes.attributes.annotationname;

    if(dataItemsContainer !== '' ){

        assignToSiblingBasedOnAttr(component,annotationName,dataItemsContainer, 'datacardimage');
        assignToSiblingBasedOnAttr(component,annotationName,dataItemsContainer, 'datacarddate');
        assignToSiblingBasedOnAttr(component,annotationName,dataItemsContainer, 'datacardtitle');
        assignToSiblingBasedOnAttr(component,annotationName,dataItemsContainer, 'datacarddescription');
        assignToSiblingBasedOnAttr(component,annotationName,dataItemsContainer, 'datacardbutton');

        assignToSiblingBasedOnAttr(component,annotationName,dataItemsContainer, 'datacardexercise1');
        assignToSiblingBasedOnAttr(component,annotationName,dataItemsContainer, 'datacardexercise2');
        assignToSiblingBasedOnAttr(component,annotationName,dataItemsContainer, 'datacardlevel');
        assignToSiblingBasedOnAttr(component,annotationName,dataItemsContainer, 'datacardstatus');

        assignToSiblingBasedOnAttr(component,annotationName,dataItemsContainer, 'shoplistimage');
        assignToSiblingBasedOnAttr(component,annotationName,dataItemsContainer, 'shoplisttext');
        assignToSiblingBasedOnAttr(component,annotationName,dataItemsContainer, 'shoplistprice');
        assignToSiblingBasedOnAttr(component,annotationName,dataItemsContainer, 'shoplistbutton');


        if(dataItemsContainer.attributes.attributes.dataitems === 'getAllRows' && component.attributes.tagName === 'td'){
            assignAnnotationToTdSiblings(annotationName,dataItemsContainer,component);
        }
        else if(dataItemsContainer.attributes.attributes.dataitems === 'getAllRows' && component.parent().attributes.tagName === 'td'){
            const childIndex = findChildIndex(component);
            assignAnnotationToInsideTbSiblings(annotationName, dataItemsContainer, component, childIndex);
        }

        
    } 

    if(component.attributes.tagName === 'li'){
        assignAnnotationToLiSiblings(editor,annotationName,component);
    }


}

const assignSameAnnotationToItemsComp = (editor) => {

    editor.on('component:update:attributes', (component) => {
        assignSameAnnotationToListItemsComp(component);
        assignSameAnnotationToGenericGetItemsComp(editor,component);      
    })

}

export default assignSameAnnotationToItemsComp;
